import React from "react";
import config from "../../../config";

export default function AppStoreLink({ href }: { href: string }) {
  const appleStoreImageUrl = `${config.ASSETS_URL}/static/ios-appstore-badge-black-2025.svg`;
  return (
    <a href={href} target='_blank' rel='noopener noreferrer'>
      <img src={appleStoreImageUrl} alt='Download on the App Store' />
    </a>
  );
}
